import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal } from "./Reveal";

export default function FAQ() {
  const { t } = useLang();
  return (
    <section id="preguntas" className="mx-auto max-w-3xl px-4 sm:px-8 py-20 sm:py-32">
      <Reveal>
        <h2 className="font-black tracking-tighter text-3xl sm:text-4xl">{t.faq.title}</h2>
      </Reveal>
      <Reveal className="mt-10">
        <Accordion type="single" collapsible className="space-y-3">
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`q${i}`}
              className="rounded-2xl border lp-hairline bg-white/[0.02] px-5 data-[state=open]:border-[#f5a623]/40"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-semibold hover:no-underline py-5"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#a1a1aa] leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
